import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PortfolioPage } from './pages/PortfolioPage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { WorkEditor } from './pages/admin/WorkEditor';
import { ProjectEditor } from './pages/admin/ProjectEditor';
import { AboutEditor } from './pages/admin/AboutEditor';
import { ExperimentsEditor } from './pages/admin/ExperimentsEditor';
import { WritingEditor } from './pages/admin/WritingEditor';
import { MusicEditor } from './pages/admin/MusicEditor';
import { ContactEditor } from './pages/admin/ContactEditor';
import { GameEditor } from './pages/admin/GameEditor';
import { MediaLibrary } from './pages/admin/MediaLibrary';
import { Settings } from './pages/admin/Settings';
import { Analytics } from './pages/admin/Analytics';
import { NotificationEditor } from './pages/admin/NotificationEditor';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { LoginPage } from './pages/admin/LoginPage';
import { AuthGuard } from './lib/auth';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Public Portfolio Routes */}
        <Route path="/" element={<PortfolioPage data-id="element-3" />} data-id="element-2" />
        <Route path="/work/:slug" element={<PortfolioPage openType="work" data-id="element-5" />} data-id="element-4" />
        <Route path="/experiments/:slug" element={<PortfolioPage openType="experiments" data-id="element-7" />} data-id="element-6" />
        <Route path="/writing/:slug" element={<PortfolioPage openType="writing" data-id="element-9" />} data-id="element-8" />
        <Route path="/music/:slug" element={<PortfolioPage openType="music" data-id="element-11" />} data-id="element-10" />
        <Route path="/project/:slug" element={<ProjectDetailPage data-id="element-13" />} data-id="element-12" />
        {/* Admin Login */}
        <Route path="/admin/login" element={<LoginPage data-id="element-15" />} data-id="element-14" />
        {/* Protected Admin CMS Routes */}
        <Route path="/admin" element={<AuthGuard data-id="element-17">
              <AdminLayout data-id="element-18" />
            </AuthGuard>} data-id="element-16">
          <Route index element={<AdminDashboard data-id="element-20" />} data-id="element-19" />
          <Route path="about" element={<AboutEditor data-id="element-22" />} data-id="element-21" />
          <Route path="work" element={<WorkEditor data-id="element-24" />} data-id="element-23" />
          <Route path="work/new" element={<ProjectEditor data-id="element-26" />} data-id="element-25" />
          <Route path="work/:id" element={<ProjectEditor data-id="element-28" />} data-id="element-27" />
          <Route path="experiments" element={<ExperimentsEditor data-id="element-30" />} data-id="element-29" />
          <Route path="writing" element={<WritingEditor data-id="element-32" />} data-id="element-31" />
          <Route path="music" element={<MusicEditor data-id="element-34" />} data-id="element-33" />
          <Route path="contact" element={<ContactEditor data-id="element-36" />} data-id="element-35" />
          <Route path="game" element={<GameEditor data-id="element-38" />} data-id="element-37" />
          <Route path="notifications" element={<NotificationEditor data-id="element-40" />} data-id="element-39" />
          <Route path="media" element={<MediaLibrary data-id="element-42" />} data-id="element-41" />
          <Route path="settings" element={<Settings data-id="element-44" />} data-id="element-43" />
          <Route path="analytics" element={<Analytics data-id="element-46" />} data-id="element-45" />
        </Route>
      </Routes>
    </BrowserRouter>;
}